module.exports = {"TXTWCL_There_are_no_markets_available_ELL":{"id":"TXTWCL_There_are_no_markets_available_ELL","defaultMessage":"Brak kategorii zakładów"}}